import BaseQuery from "../BaseQuery";

export default class GetRetentionPolicyQuery extends BaseQuery {

  constructor() {
    super();
  }

  public override ConstructQueryString(): void {}

  public GetEndpoint(): string {
    return "auth/retention-policy";
  }
}